import * as flipperFlags from './flipperFlags';
import * as productFlags from './productFlags';

export type FlipperFlag = string;
export type ProductFlag = string;

type ProductFlipperFlagRelation = {
  name: string;
  product: ProductFlag;
  flipper: FlipperFlag;
};

export const AD_LINK_MANAGER: ProductFlipperFlagRelation = {
  name: 'Ad Link Manager',
  product: productFlags.AD_LINK_MANAGER,
  flipper: flipperFlags.AD_LINK_MANAGER,
};

export const AD_LINK_TEMPLATES: ProductFlipperFlagRelation = {
  name: 'Ad Link Templates',
  product: productFlags.AD_LINK_TEMPLATES,
  flipper: flipperFlags.AD_LINK_TEMPLATES,
};

export const BULK_AD_LINKS: ProductFlipperFlagRelation = {
  name: 'Bulk Ad Links',
  product: productFlags.BULK_AD_LINKS,
  flipper: flipperFlags.BULK_AD_LINKS,
};

export const BULK_QUICK_LINKS: ProductFlipperFlagRelation = {
  name: 'Bulk Quick Links',
  product: productFlags.BULK_QUICK_LINKS,
  flipper: flipperFlags.BULK_QUICK_LINKS,
};

export const QUICK_LINK_MANAGER: ProductFlipperFlagRelation = {
  name: 'Quick Link Manager',
  product: productFlags.QUICK_LINK_MANAGER,
  flipper: flipperFlags.QUICK_LINK_MANAGER,
};

export const QUICK_LINK_TEMPLATES: ProductFlipperFlagRelation = {
  name: 'Quick Link Templates',
  product: productFlags.QUICK_LINK_TEMPLATES,
  flipper: flipperFlags.QUICK_LINK_TEMPLATES,
};

export const SEO_APP_ATTRIBUTION: ProductFlipperFlagRelation = {
  name: 'SEO App Attribution',
  product: productFlags.SEO_APP_ATTRIBUTION,
  flipper: flipperFlags.SEO_ORGANIC_SEARCH,
};

export const productFlipperFlagRelations: ProductFlipperFlagRelation[] = [
  AD_LINK_MANAGER,
  AD_LINK_TEMPLATES,
  BULK_AD_LINKS,
  BULK_QUICK_LINKS,
  QUICK_LINK_MANAGER,
  QUICK_LINK_TEMPLATES,
  SEO_APP_ATTRIBUTION,
];
